<template>
    <div class="wineguide-container">
        <div class="itips-head">
            <div class="container">
                <div class="inner-page-title">{{ $t("home-top4") }}</div>
                <div class="inenr-page-breadcrumb">
                    <div class="inner-page-bread-line"></div>
                </div>
            </div>
        </div>
        <div class="container">
            <div class="wine-guide-body">
                <div class="wine-guide-left hide-mobile">
                    <div class="wine-guide-left-title">
                        <nuxt-link class="wine-guide-back" :to="localePath('/wine-guide/usa/napa')"></nuxt-link>
                        Producers
                    </div>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/usa/napa/abreu-vineyards')">Abreu Vineyards
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/usa/napa/caymus-vineyards')">Caymus vineyards
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/usa/napa/christian-moueix-dominus')">Christian Moueix -
                        Dominus
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/usa/napa/colgin-cellars')">Colgin Cellars
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/usa/napa/harlan-estates')">Harlan Estates
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country active"
                               :to="localePath('/wine-guide/usa/napa/kapcsandy-winery')">Kapcsandy Winery
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/usa/napa/opus-one')">Opus One
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/usa/napa/robert-mondovi-vineyards')">Robert Mondovi
                        Vineyards
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/usa/napa/scarecrow-wines')">Scarecrow Wines
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/usa/napa/schrader-cellars')">Schrader Cellars
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/usa/napa/screaming-eagle')">Screaming Eagle
                    </nuxt-link>
                </div>
                <div class="show-mobile">
                    <div class="wine-guide-left-title">
                        <nuxt-link class="wine-guide-back" :to="localePath('/wine-guide/usa/napa')"></nuxt-link>
                        Producers
                    </div>
                    <v-select
                        :items="items"
                        v-model="select"
                        label="Please choose"
                        single-line
                        item-text="report"
                        item-value="src"
                        return-object
                        class="show-mobile show-mobile-select"
                        v-on:change="changeRoute"
                    ></v-select>
                </div>
                <div v-if="$i18n.locale === 'it'" class="wine-guide-right">
                    <div class="howto-title">Azienda vinicola Kapcsandy</div>
                    <div class="howto-separator"></div>
                    <div class="howto-text">
                        Con aumenti anno dopo anno per il Cabernet Sauvignon californiano che superano di gran lunga quelli per
                        Vini francesi, (soprattutto Borgogna e Bordeaux), sempre più investitori cercano il
                        prossima grande cosa quando si tratta di separarsi dai loro soldi. Diversi vigneti blue-chip hanno realizzato a
                        nome per se stessi (Screaming Eagle ovviamente ma anche Dominus e Colgin) ma ci sono
                        ancora molte aziende vinicole della Napa Valley producono eccezionali Cabernet Sauvignon che valgono il nostro
                        tempo e denaro. Kapcsandy Family Winery è uno di questi posti.
                    </div>

                    <div class="howto-title2">Il sogno americano</div>
                    <div class="howto-text">
                        Creato dall'ungherese Lou Kapcsandy, questa è una storia da stalle a ricchezze. In fuga da Budapest nel 1956,
                        è arrivato negli Stati Uniti senza documenti, soldi e nemmeno una parola di inglese. Dopo aver trovato lavoro in a
                        panificio, ha prestato servizio per due anni nell'esercito americano e, una volta rilasciato, si è fatto strada fino al
                        scala aziendale in Ingegneria Chimica. Fenomenale successo, dopo il suo ritiro nel 1999
                        dichiarava di essere sempre stato francofilo e di voler aprire una piccola attività di importazione
                        il suo Bordeaux preferito negli Stati Uniti. Tuttavia, gli uomini con ambizione e visione non smettono di essere
                        ambiziosi o visionari solo perché sono andati in pensione. Nel 2000, Lou e sua moglie Bobbie
                        acquistò la State Lane Vineyards a Yountville, Napa Valley, con l'intento di produrre Cabernet
                        Sauvignon per il loro consumo personale. Purtroppo, le viti sono state colpite dalla fillossera e l'hanno avuta
                        per essere ripiantato nel 2002, un'impresa enorme che ha fatto con l'aiuto del leggendario enologo
                        Helen Turley e suo marito John Wetlaufer. Ci sarebbero voluti altri sette anni prima di Kapcsandy
                        le cantine producevano un vino che Lou riteneva degno del suo nome.
                    </div>

                    <div class="howto-title2">Un'azienda vinicola della Napa Valley da tenere d'occhio</div>
                    <div class="howto-text">
                        Nel 2005 Lou ha introdotto l'enologo Denis Malbec della fama di Château Latour. Questo potrebbe essere considerato un
                        punto di svolta per Kapcsandy, e sicuramente quando critici e consumatori hanno cominciato a notare il suo
                        Cabernet Sauvignon di altissima qualità. Equiparando i suoi vini a quelli di Paulliac e
                        Pomerol, il guru del vino Robert Parker ha siglato l'affare di Kapcsandy quando li ha nominati tra i migliori
                        cinque cantine nella Napa Valley. Inoltre, bassa produzione (5.000 casse per il Grand Vin) e
                        punteggi più alti (il 2013 ha ricevuto punteggi di 99 da Wine Advocate e 98 da Vinous) fanno di Kapcsandy un
                        valido concorrente quando si considera un portafoglio di vini pregiati.
                    </div>
                </div>
                <div v-else-if="$i18n.locale === 'de'" class="wine-guide-right">
                    <div class="howto-title">Kapcsandy Winery</div>
                    <div class="howto-separator"></div>
                    <div class="howto-text">
                        Mit jährlichen Steigerungen für kalifornischen Cabernet Sauvignon, die die für kalifornischen Cabernet Sauvignon deutlich übertreffen
                        Nach französischen Weinen (vor allem Burgunder und Bordeaux) suchen immer mehr Investoren
                        die nächste große Sache, wenn es darum geht, sich von ihrem Geld zu trennen. Mehrere Blue-Chip-Weinberge haben eine gemacht
                        Namen für sich (Screaming Eagle natürlich, aber auch Dominus und Colgin), aber es gibt sie
                        Es gibt immer noch viele Weingüter im Napa Valley, die außergewöhnlichen Cabernet Sauvignon produzieren, der einen Besuch wert ist
                        Zeit und Geld. Das Kapcsandy Family Winery ist ein solcher Ort.
                    </div>

                    <div class="howto-title2">Der amerikanische Traum</div>
                    <div class="howto-text">
                        Erstellt vom Ungar Lou Kapcsandy, ist dies eine Geschichte vom Tellerwäscher zum Millionär. Flucht aus Budapest im Jahr 1956,
                        Er kam ohne Papiere, Geld und auch nur ein Wort Englisch in die USA. Nachdem ich Arbeit in einem gefunden habe
                        Er diente zwei Jahre lang in der amerikanischen Armee und arbeitete sich nach seiner Entlassung hoch
                        Karriereleiter im Chemieingenieurwesen. Phänomenal erfolgreich, nach seiner Pensionierung im Jahr 1999
                        Er erklärte, er sei schon immer ein Frankophiler gewesen und wolle ein kleines Importunternehmen eröffnen
                        seine Lieblings-Bordeaux’s in die USA. Männer mit Ehrgeiz und Vision hören jedoch nicht auf zu sein
                        ehrgeizig oder visionär, nur weil sie im Ruhestand sind. Im Jahr 2000, Lou und seine Frau Bobbie
                        kaufte die State Lane Vineyards in Yountville, Napa Valley, mit der Absicht, Cabernet herzustellen
                        Sauvignon für den persönlichen Verzehr. Leider waren die Reben von der Reblaus befallen
                        im Jahr 2002 neu bepflanzt werden, ein riesiges Unterfangen, das er mit Hilfe des legendären Winzers durchführte
                        Helen Turley und ihr Ehemann John Wetlaufer. Es sollte noch sieben Jahre dauern, bis Kapcsandy erschien
                        Weingüter produzierten einen Wein, den Lou seines Namens für würdig hielt.
                    </div>

                    <div class="howto-title2">Ein Weingut im Napa Valley, das man sich ansehen sollte</div>
                    <div class="howto-text">
                        Im Jahr 2005 holte Lou den Winzer Denis Malbec vom berühmten Château Latour. Dies könnte als a angesehen werden
                        Es war ein Wendepunkt für Kapcsandy, und ganz sicher, als Kritiker und Verbraucher ihn bemerkten
                        außergewöhnlich hochwertige Cabernet Sauvignons. Er gleicht seine Weine mit denen von Paulliac und aus
                        Pomerol, Wein-Guru Robert Parker besiegelte Kapcsandys Deal, als er sie zu einem der Besten ernannte
                        fünf Weingüter im Napa Valley. Darüber hinaus geringe Produktion (5.000 Kisten für den Grand Vin) und
                        Hohe Punktzahlen (2013 erhielt er 99 Punkte von Wine Advocate und 98 Punkte von Vinous) machen Kapcsandy zu einem
                        ein echter Anwärter, wenn es um ein erlesenes Weinportfolio geht.
                    </div>
                </div>
                <div v-else-if="$i18n.locale === 'fr'" class="wine-guide-right">
                    <div class="howto-title">Vignoble Kapcsandy</div>
                    <div class="howto-separator"></div>
                    <div class="howto-text">
                        Avec des augmentations d'une année sur l'autre pour le Cabernet Sauvignon californien dépassant largement celles du
                        Vins français, (surtout Bourgogne et Bordeaux), de plus en plus d'investisseurs recherchent le
                        prochaine grande chose quand il s'agit de se séparer de leur argent. Plusieurs vignobles de premier ordre ont fait une
                        nom pour eux-mêmes (Screaming Eagle évidemment mais Dominus et Colgin aussi) mais il y a
                        encore de nombreux vignobles de Napa Valley produisant des Cabernet Sauvignon exceptionnels qui valent bien notre
                        du temps et de l'argent. Kapcsandy Family Winery est l'un de ces endroits.
                    </div>

                    <div class="howto-title2">Le rêve américain</div>
                    <div class="howto-text">
                        Créé par le Hongrois Lou Kapcsandy, c'est une histoire de chiffons à la richesse. Fuyant Budapest en 1956,
                        il est arrivé aux États-Unis sans papiers, sans argent ni même un mot d'anglais. Après avoir trouvé du travail dans un
                        boulangerie, il a servi pendant deux ans dans l'armée américaine et, à sa libération, a gravi les échelons
                        échelle d'entreprise en génie chimique. Un succès phénoménal, à sa retraite en 1999
                        il déclare avoir toujours été francophile et veut ouvrir un petit commerce d'importation
                        ses Bordeaux préférés aux États-Unis. Cependant, les hommes ambitieux et visionnaires ne cessent pas d'être
                        ambitieux ou visionnaire simplement parce qu'ils ont pris leur retraite. En 2000, Lou et sa femme Bobbie
                        a acheté les State Lane Vineyards à Yountville, Napa Valley, avec l'intention de faire du Cabernet
                        Sauvignon pour leur consommation personnelle. Malheureusement, la vigne a été touchée par le phylloxéra et a
                        à replanter en 2002, une entreprise colossale qu'il a menée avec l'aide d'un vigneron légendaire
                        Helen Turley et son mari John Wetlaufer. Il faudrait encore sept ans avant que Kapcsandy
                        les caves ont produit un vin que Lou a jugé digne de son nom.
                    </div>

                    <div class="howto-title2">Un domaine viticole de Napa Valley à surveiller</div>
                    <div class="howto-text">
                        En 2005, Lou a fait appel au vigneron Denis Malbec de la renommée Château Latour. Cela pourrait être considéré comme un
                        tournant pour Kapcsandy, et certainement lorsque les critiques et les consommateurs ont commencé à remarquer son
                        Cabernet Sauvignon d'une qualité exceptionnelle. Assimilant ses vins à ceux de Paulliac et
                        Pomerol, le gourou du vin Robert Parker a conclu l'accord de Kapcsandy lorsqu'il les a nommés parmi les meilleurs
                        cinq établissements vinicoles dans la vallée de Napa. De plus, la faible production (5 000 caisses pour le Grand Vin) et
                        des scores élevés (2013 ont reçu des scores de 99 de Wine Advocate et 98 de Vinous) font de Kapcsandy un
                        concurrent viable lors de l'examen d'un portefeuille de vins fins.
                    </div>
                </div>
                <div v-else class="wine-guide-right">
                    <div class="howto-title">Kapcsandy Winery</div>
                    <div class="howto-separator"></div>
                    <div class="howto-text">
                        With year on year increases for Californian Cabernet Sauvignon well outstripping those for
                        French wines, (especially Burgundy and Bordeaux), more and more investors are looking for the
                        next big thing when it comes to parting with their cash. Several blue-chip vineyards have made a
                        name for themselves (Screaming Eagle obviously but Dominus and Colgin as well) but there are
                        still many Napa Valley wineries producing exceptional Cabernet Sauvignon that are well worth our
                        time and money. Kapcsandy Family Winery is one such place.
                    </div>

                    <div class="howto-title2">The American Dream</div>
                    <div class="howto-text">
                        Created by Hungarian Lou Kapcsandy, this is a rags to riches story. Escaping Budapest in 1956,
                        he arrived in the US without papers, money or even a word of English. After finding work in a
                        bakery, he served for two years in the American army, and upon release, worked his way up the
                        corporate ladder in Chemical Engineering. Phenomenally successful, upon his retirement in 1999
                        he declared that he had always been a francophile and wanted to open a little business importing
                        his favourite Bordeaux’s into the US. However, men with ambition and vision do not stop being
                        ambitious or visionary just because they have retired. In 2000, Lou and his wife Bobbie
                        purchased the State Lane Vineyards in Yountville, Napa Valley, with the intent to make Cabernet
                        Sauvignon for their personal consumption. Sadly, the vines were affected with phylloxera and had
                        to be replanted in 2002, a huge undertaking that he did with the help of legendary winemaker
                        Helen Turley and her husband John Wetlaufer. It would take another seven years before Kapcsandy
                        wineries produced a wine that Lou deemed worthy of his name.
                    </div>

                    <div class="howto-title2">A Napa Valley winery to watch</div>
                    <div class="howto-text">
                        In 2005 Lou brought in winemaker Denis Malbec of Château Latour fame. This could be considered a
                        turning point for Kapcsandy, and certainly when critics and consumers began to notice his
                        exceptionally high-quality Cabernet Sauvignons. Equating his wines to those of Paulliac and
                        Pomerol, wine guru Robert Parker sealed Kapcsandy’s deal when he named them as one of the top
                        five wineries in Napa Valley. Additionally, low production (5,000 cases for the Grand Vin) and
                        high scores (2013 received scores of 99 from Wine Advocate and 98 from Vinous) make Kapcsandy a
                        viable contender when considering a fine wine portfolio.
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "KapcsandyWinery",
    head: {
        title: 'Kapcsandy Winery | Vindome Wine Guide',
        meta: [
            {
                hid: 'description',
                name: 'description',
                content: 'Discover the elegance and sophistication of Kapcsandy Winery\'s wines, crafted from the finest Napa Valley grapes. Experience the ultimate in quality and taste with every sip.'
            }
        ],
        bodyAttrs: {
            class: 'wine-guide inner-page'
        }
    },
    data() {
        return {
            select: {report: 'Kapcsandy Winery', src: '/wine-guide/usa/napa/kapcsandy-winery'},
            items: [
                {report: 'Abreu Vineyards', src: '/wine-guide/usa/napa/abreu-vineyards'},
                {report: 'Caymus vineyards', src: '/wine-guide/usa/napa/caymus-vineyards'},
                {report: 'Christian Moueix - Dominus', src: '/wine-guide/usa/napa/christian-moueix-dominus'},
                {report: 'Colgin Cellars', src: '/wine-guide/usa/napa/colgin-cellars'},
                {report: 'Harlan Estates', src: '/wine-guide/usa/napa/harlan-estates'},
                {report: 'Kapcsandy Winery', src: '/wine-guide/usa/napa/kapcsandy-winery'},
                {report: 'Opus One', src: '/wine-guide/usa/napa/opus-one'},
                {report: 'Robert Mondovi Vineyards', src: '/wine-guide/usa/napa/robert-mondovi-vineyards'},
                {report: 'Scarecrow Wines', src: '/wine-guide/usa/napa/scarecrow-wines'},
                {report: 'Schrader Cellars', src: '/wine-guide/usa/napa/schrader-cellars'},
                {report: 'Screaming Eagle', src: '/wine-guide/usa/napa/screaming-eagle'}
            ]
        }
    },
    methods: {
        changeRoute(a) {
                this.$router.push({path: this.localePath(a.src) });
            }
    }
}
</script>

<style scoped>
.container {
    max-width: 1170px;
    padding: 0;
    font-family: 'Poppins', sans-serif;
}

.wine-guide-body {
    padding-top: 35px;
}

.wine-guide-left {
    width: 300px;
    display: inline-block;
}

.wine-guide-right {
    display: inline-block;
    width: calc(100% - 305px);
    vertical-align: top;
}

.wine-guide-left-title {
    font-weight: 600;
    color: #024E7B;
    font-size: 18px;
    height: 57px;
    line-height: 57px;
}

.wine-guide-country {
    display: block;
    height: 57px;
    line-height: 57px;
    text-decoration: none;
    color: #000;
    font-size: 16px;
    padding-left: 30px;
    width: 260px;
    border-left: 3px solid transparent;
}

.wine-guide-country:hover,
.wine-guide-country.active {
    border-color: #024E7B;
    background: #E5EDF2;
}
</style>
